
export const hexToHSL = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);

    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if (max == min) {
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);

    var colorInHSL = { h: h, s: s, l: l };
    return colorInHSL;
}
export const hslToHex = (h, s, l) => {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

const hexToLab = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
    if (!result) {
        return null;
    }

    const rgb = result.slice(1).map(value => {
        const channel = parseInt(value, 16) / 255;
        return channel > 0.04045
            ? Math.pow((channel + 0.055) / 1.055, 2.4)
            : channel / 12.92;
    });
    const x = (rgb[0] * 0.4124 + rgb[1] * 0.3576 + rgb[2] * 0.1805) / 0.95047;
    const y = rgb[0] * 0.2126 + rgb[1] * 0.7152 + rgb[2] * 0.0722;
    const z = (rgb[0] * 0.0193 + rgb[1] * 0.1192 + rgb[2] * 0.9505) / 1.08883;
    const transform = value => value > 0.008856
        ? Math.pow(value, 1 / 3)
        : (7.787 * value) + (16 / 116);
    const transformedX = transform(x);
    const transformedY = transform(y);
    const transformedZ = transform(z);

    return {
        l: (116 * transformedY) - 16,
        a: 500 * (transformedX - transformedY),
        b: 200 * (transformedY - transformedZ),
    };
}

const labDistanceSquared = (first, second) => (
    Math.pow(first.l - second.l, 2)
    + Math.pow(first.a - second.a, 2)
    + Math.pow(first.b - second.b, 2)
);

export const getMostDistinctColour = (colours) => {
    const existingColours = colours
        .map(hexToLab)
        .filter(colour => colour !== null);

    if (existingColours.length === 0) {
        return hslToHex(210, 75, 50);
    }

    let bestColour = null;
    let bestMinimumDistance = -1;
    const saturations = [55, 70, 85, 100];
    const lightnesses = [30, 40, 50, 60, 70];

    for (let hue = 0; hue < 360; hue += 5) {
        for (const saturation of saturations) {
            for (const lightness of lightnesses) {
                const candidate = hslToHex(hue, saturation, lightness);
                const candidateLab = hexToLab(candidate);
                const minimumDistance = Math.min(...existingColours.map(
                    colour => labDistanceSquared(candidateLab, colour)
                ));

                if (minimumDistance > bestMinimumDistance) {
                    bestColour = candidate;
                    bestMinimumDistance = minimumDistance;
                }
            }
        }
    }

    return bestColour;
}

export const getRecentCropColours = (rows, currentYear = new Date().getFullYear()) => rows
    .filter(row => {
        const yearText = `${row.crop || ''}`.slice(0, 4);
        return !/^\d{4}$/.test(yearText) || Number(yearText) > currentYear - 4;
    })
    .map(row => row.colour);